export default "__VITE_ASSET__LfpKg_SU__"